var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.667H2.66667M14 14.667H13.3333M2.66667 14.667V5.86699C2.66667 4.74689 2.66667 4.18683 2.88465 3.75901C3.0764 3.38269 3.38236 3.07673 3.75869 2.88498C4.18651 2.66699 4.74656 2.66699 5.86667 2.66699H6.13333C7.25344 2.66699 7.81349 2.66699 8.24131 2.88498C8.61764 3.07673 8.9236 3.38269 9.11535 3.75901C9.33333 4.18683 9.33333 4.74689 9.33333 5.86699V6.00033M2.66667 14.667H6H9.33333M9.33333 14.667V6.00033M9.33333 14.667H13.3333M9.33333 6.00033H11.7333C12.2934 6.00033 12.5734 6.00033 12.7873 6.10932C12.9755 6.20519 13.1285 6.35817 13.2243 6.54634C13.3333 6.76025 13.3333 7.04027 13.3333 7.60033V14.667M11.3333 8.66033V8.66699M11.3333 12.0003V12.007",
    stroke: "#29B77E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 5.3335H6.66658M5.33325 8.66683H6.66658M5.33325 12.0002H6.66658",
    stroke: "#29B77E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarks);
export default __webpack_public_path__ + "static/media/landmarks.5034828e31291a59938555cf9d55b822.svg";
export { ForwardRef as ReactComponent };